import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import {get} from 'lodash'
import FormField, {
  AsyncListField,
  BooleanField,
  CampaignSelectorField,
  CheckBoxField,
  CheckBoxTextField,
  CompanyListField,
  ContactDetailsField,
  ContactListField,
  CurrencyField,
  DateField,
  DateRangeField,
  DateTimeField,
  DeliveryNoteListField,
  DurationPicker,
  EmailField,
  LabelField,
  ListField,
  MemoField,
  MultiListField,
  NumberField,
  OpportunityListField,
  OrderListField,
  OrderSelectorField,
  PackTypeListField,
  PartCategoryListField,
  PhoneField,
  ReferenceListField,
  RepeatDaysField,
  RepeatEndPeriodField,
  RepeatMonthsField,
  SeparatorField,
  StringField,
  TimeField,
  TimeSpentField,
} from 'components/formField'
import './editableField.scss'

const getClassName = prefix('editableField-')

class EditableField extends Component {
  constructor(props) {
    super(props)
  }

  getField = (field) => {
    const {validateState, onChange, autoFocusDelay} = this.props
    return {
      ...field,
      autoFocusDelay,
      fieldKey: field.key,
      validateState,
      onChange: (...params) => onChange && onChange(field, ...params),
    }
  }

  getEditor = (field) => {
    switch (field.dataType) {
      case 'Label':
        return <LabelField {...field}/>
      case 'String':
        return <StringField
            {...field}
            immediate={get(field, 'immediate', true)}/>
      case 'Email':
        return <EmailField {...field} immediate/>
      case 'Phone':
      case 'Mobile':
        return <PhoneField {...field} immediate/>
      case 'Number':
        return <NumberField {...field} />
      case 'Boolean':
        return <BooleanField {...field} />
      case 'List':
        return <ListField {...field} />
      case 'Date':
        return <DateField {...field} />
      case 'Time':
        return <TimeField {...field} />
      case 'Date Time':
        return <DateTimeField {...field} />
      case 'Multi List':
        return <MultiListField {...field} />
        // TODO: Support 'Lookup' (see editablePivotTable/cellEditor)
      case 'Lookup':
        return <AsyncListField
            {...field}
            loadOptions={this.loadLookupItems(field)}/>
      case 'Memo':
        return <MemoField
            {...field}
            immediate={get(field, 'immediate', true)}/>
      case 'Currency':
        return <CurrencyField {...field} />
      case 'Date Range':
        return <DateRangeField {...field} />
      case 'Company List':
        return <CompanyListField {...field} />
      case 'Contact List':
        return <ContactListField {...field} />
      case 'Opportunity List':
        return <OpportunityListField {...field} />
      case 'Reference List':
        return <ReferenceListField {...field} />
      case 'Order List':
        return <OrderListField {...field} />
      case 'Delivery Note List':
        return <DeliveryNoteListField {...field} />
      case 'Order Selector':
        return <OrderSelectorField {...field} />
      case 'Campaign Selector':
        return <CampaignSelectorField {...field} />
      case 'Duration Picker':
        return <DurationPicker {...field} />
      case 'Repeat Days':
        return <RepeatDaysField {...field} />
      case 'Repeat Months':
        return <RepeatMonthsField {...field} />
      case 'End Period':
        return <RepeatEndPeriodField {...field} />
      case 'Time Spent':
        return <TimeSpentField {...field} />
      case 'Pack Types':
        return <PackTypeListField {...field} />
      case 'Part Category':
        return <PartCategoryListField {...field} />
      case 'Contact Details':
        return <ContactDetailsField {...field} />
      case 'CheckBox':
        return <CheckBoxField {...field} />
      case 'CheckBoxWithText':
        return <CheckBoxTextField {...field} />
      case 'Separator':
        return <SeparatorField {...field} />
      default:
        return (
            <FormField label={field.label}>
              {`(unsupported type '${field.dataType}')`}
            </FormField>
        )
    }
  }

  loadLookupItems = (field) => (input, callback) => {
    const entity = {}
    field = {...field, data: () => field.value}

    if (field.getItems) {
      Promise.resolve(field.getItems(input, entity)).then(options => {
        callback(null, {options: options || []})
      })
    } else {
      callback(null, {
        options: [{
          value: -1,
          label: 'WARNING: Column does not support getItems',
        }],
      })
    }
  }

  render() {
    const {field, subField} = this.props
    return (
        <div className={getClassName(['container', field.field])}>
          {this.getEditor(this.getField(field))}
          {subField && this.getEditor(this.getField(subField))}
        </div>
    )
  }
}

const fieldPropType = propTypes.shape({
  key: propTypes.string.isRequired,
  dataType: propTypes.string.isRequired,
  field: propTypes.string,
  label: propTypes.node,
  active: propTypes.bool,
  order: propTypes.number,
  readOnly: propTypes.bool,
  mandatory: propTypes.bool,
})

EditableField.propTypes = {
  field: fieldPropType.isRequired,
  subField: fieldPropType,
  validateState: propTypes.bool,
  onChange: propTypes.func,
  autoFocusDelay: propTypes.number,
}

export default EditableField
